import { Component } from 'react';
import {
  Menu,
  X,
  Bell,
  Clock,
  LogIn,
  ChevronDown,
  Home,
  Users,
  Calendar,
  Phone,
  LanguagesIcon,
  UserRoundPlus,
} from 'lucide-react';
import '../../styles/components/navbar.scss';
import { Link } from 'react-router-dom';
import i18n from '../../i18n';
import { getNotificationCounts } from './services/Navbar';

function logout(callback) {
  localStorage.removeItem("is_logged_in");
  localStorage.removeItem("token");
  localStorage.removeItem("mzad_user_info");
  if (callback) callback();
  window.location.href = "/";
}

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      currentTime: new Date(),
      isProfileOpen: false,
      language: localStorage.getItem("I18N_LANGUAGE") || "en", // 👈 load from storage
      userName: 'John Doe', // Change to 'Guest' if not logged in
      isLoggedIn: false, // Change to false for guest mode
      notificationCount: 0,
      walletShow: false
    };
  }

  async componentDidMount() {
    // Update time every second
    this.timeInterval = setInterval(() => {
      this.setState({ currentTime: new Date() });
    }, 1000);

    const token = localStorage.getItem("token");
    const userInfo = JSON.parse(localStorage.getItem("mzad_user_info") || "{}");

    if (token) {
      this.setState({
        isLoggedIn: true,
        userName: userInfo?.name || "User",
      });

      // Fetch notification count
      const res = await getNotificationCounts();
      console.log("res")
      console.log(res)
      if (res?.status && res?.count !== undefined) {
        this.setState({ notificationCount: res.count });
      }
    }
  }




  componentWillUnmount() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }

  toggleMenu = () => {
    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  };

  toggleLanguage = () => {
    this.setState(
      (prevState) => {
        const newLang = prevState.language === 'en' ? 'ar' : 'en';
        return { language: newLang };
      },
      () => {
        const { language } = this.state;

        // Change language
        i18n.changeLanguage(language);

        // Save to localStorage
        localStorage.setItem("I18N_LANGUAGE", language);

        // Refresh page to apply translations globally
        window.location.reload();
      }
    );
  };


  formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Riyadh',
    });
  };

  formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      timeZone: 'Asia/Riyadh',
    });
  };



  toggleProfileMenu = () => {
    this.setState((prev) => ({ isProfileOpen: !prev.isProfileOpen }));
  };

  render() {
    const { isMenuOpen, currentTime, isProfileOpen, userName, isLoggedIn, notificationCount } =
      this.state;
    let { wallet_amount } = this.props;
    const navItems = [
      { name: 'home', icon: Home, href: '/' },
      { name: 'aboutus', icon: Users, href: '/about' },
      { name: 'auction_calendar', icon: Calendar, href: '/auc-calendar' },
      { name: 'contactus', icon: Phone, href: '/contact' },
    ];

    return (
      <>
        
        <nav className="navbar">
          <div className="navbar-container">
            {/* Logo Section */}
            <div className="logo-section">
              <Link to="/home" className="logo">
                <img
                  src="/assets/images/l-1.svg"
                  alt="Company Logo"
                  style={{ width: '100%', height: '100%' }}
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <ul className="nav-menu">
              {navItems.map((item, index) => (
                <li key={index} className="nav-item">
                  <Link to={item.href} className="nav-link">
                    {/* <item.icon size={16} /> */}
                    {i18n.t(item.name)}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Actions Section */}
            <div className="nav-actions">
              {/* Time Display */}
              <div className="time-display-container">
                <div className="time-section">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/flags/saudi-new.svg`}
                    height="20"
                    width="28"
                    alt="Saudi Arabia Flag"
                    className="flag-icon"
                  />
                  <span className="current-time">{this.formatTime(currentTime)}</span>
                </div>
                <div className="date-section">
                  <span className="current-date">{this.formatDate(currentTime)}</span>
                </div>
              </div>

              {/* Language Switcher */}
              <div className="language-switcher" onClick={this.toggleLanguage}>
                <LanguagesIcon size={16} className="lang-icon" />
                <span className="lang-text">
                  {localStorage.getItem("I18N_LANGUAGE") === "en" ? "AR" : "EN"}
                </span>
              </div>

              {/* Notification Bell */}
              {isLoggedIn && (
                <Link style={{ color: "black" }} to="/notifications" >
                  <div className="notification-btn">
                    <Bell size={18} />
                    {notificationCount > 0 && (
                      <div className="notification-badge">{notificationCount}+</div>
                    )}
                  </div>
                </Link>
              )}

              {/* User Profile or Login */}
              {isLoggedIn && (
                <div className="user-profile" onClick={this.toggleProfileMenu}>
                  <div className="avatar">{userName.charAt(0).toUpperCase()}</div>
                  <span className="user-name">{userName}</span>
                  <ChevronDown size={14} />
                  {isProfileOpen && (

                    <div className="profile-dropdown">

                      <Link to="/wallet" className="dropdown-wallet">
                        {i18n.t('wallet')} :
                        <span
                          style={{ cursor: "pointer", marginLeft: "6px" }}
                          onClick={() => this.setState(prev => ({ walletShow: !prev.walletShow }))}
                        >
                          {this.state.walletShow ? wallet_amount : "*****"}
                        </span>
                      </Link>


                      <Link to="/dashboard" className="dropdown-item">
                        Dashboard
                      </Link>

                      <Link to="/profile" className="dropdown-item">
                        Profile
                      </Link>
                      <button
                        className="dropdown-item"
                        onClick={() => logout(() => this.setState({ isLoggedIn: false }))}
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* Login Button (show only if not logged in) */}
              {!isLoggedIn && (
                <>
                  <Link to="/login" className="Q-btn">
                    <LogIn size={16} />
                    {i18n.t('login')}
                  </Link>

                  <Link to="/register" className="Q-btn Q-btn--register">
                  <UserRoundPlus size={16} />
                    {i18n.t('register')}
                  </Link>
                </>

              )}
              {/* {isLoggedIn && (
                <button
                  onClick={() => logout(() => this.setState({ isLoggedIn: false }))}
                  className="Q-btn"
                >
                  <LogOut size={16} />
                  {i18n.t("logout")}
                </button>
              )} */}


              {/* Mobile Menu Button */}
              <button className="mobile-menu-btn" onClick={this.toggleMenu}>
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
            <div className="mobile-nav-menu">
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.href}
                  className="mobile-nav-link"
                  onClick={() => this.setState({ isMenuOpen: false })}
                >
                  <item.icon size={18} />
                  {i18n.t(item.name)}
                </Link>
              ))}
            </div>

            <div className="mobile-actions">
              <div className="time-display">
                <div className="time">
                  <Clock size={12} style={{ display: 'inline', marginRight: '4px' }} />
                  {this.formatTime(currentTime)}
                </div>
                <div className="date">{this.formatDate(currentTime)}</div>
              </div>

              {!isLoggedIn && (
                <Link
                  to="/login"
                  className="L-btn"
                  onClick={() => this.setState({ isMenuOpen: false })}
                >
                  <LogIn size={16} />
                  Login
                </Link>
              )}
            </div>
          </div>
        </nav>

        {/* Demo Content */}
        {/* <div
          style={{
            // height: '200vh',
            background:
              'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 25%, #a7f3d0 50%, #6ee7b7 75%, #34d399 100%)',
            padding: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            color: '#1b8f9b',
          }}
        >
          <div
            style={{
              textAlign: 'center',
              background: 'rgba(255, 255, 255, 0.9)',
              padding: '3rem',
              borderRadius: '20px',
              backdropFilter: 'blur(10px)',
            }}
          >
            <h1
              style={{
                fontSize: '3rem',
                fontWeight: 'bold',
                background:
                  'linear-gradient(135deg, #1b8f9b 0%, #16a085 25%, #2dd4bf 50%, #06b6d4 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '20px',
              }}
            >
              Coming Soon
            </h1>
            <p style={{ fontSize: '1.25rem', color: '#065f46' }}>
              Our website is under construction. We’ll be launching soon!
            </p>
          </div>
        </div> */}
      </>
    );
  }
}

export default Navbar;

